module.exports = __webpack_public_path__ + "static/media/054-canary-islands.f2c764c3.svg";